var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C10.0825 45 0 34.9175 0 22.5C0 10.0825 10.0825 0 22.5 0C34.9175 0 45 10.0825 45 22.5C45 34.9133 34.9175 45 22.5 45ZM33.7489 13.4996L31.4983 11.2489L22.4979 20.2494L13.4975 11.2489L11.2468 13.4996L20.2473 22.5L11.2468 31.5004L13.4975 33.7511L22.4979 24.7506L31.4983 33.7511L33.7489 31.5004L24.7485 22.5L33.7489 13.4996Z",
    fill: "#58585A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.c0afed16464a29d6297fab1c50f26e95.svg";
export { ForwardRef as ReactComponent };